import moment from "moment-timezone";

export class Helpers {
  static emailMask(email) {
    let maskedEmail = email.replace(/([^@.])/g, "*").split("");
    let previous = "";
    for (let i = 0; i < maskedEmail.length; i++) {
      if (i <= 1 || previous === "." || previous === "@") {
        maskedEmail[i] = email[i];
      }
      previous = email[i];
    }
    return maskedEmail.join("");
  }
  static dateMaskString(date) {
    return moment(date).format("ll");
  }
  static secondsInTime(seconds) {
    return seconds && seconds > 0
      ? seconds > 3600
        ? moment.utc(seconds * 1000).format("HH:mm:ss")
        : moment.utc(seconds * 1000).format("mm:ss")
      : "";
  }
  static limitString(string, limit = 90) {
    return string.length > limit
      ? string.trim().substring(0, limit) + "..."
      : string;
  }
}
